export default __webpack_public_path__ + "static/media/all.d7fc89b8.svg";